import sha256 from "crypto-js/sha256";

export const _generateHash = (string: string): string => {
  return sha256(string).toString();
};

const _saveDeviceToLocalStorage = (device: any) => {
  const storageKey = "readers";
  let devices: any = localStorage.getItem(storageKey);
  if (!devices) {
    devices = [];
  } else {
    devices = JSON.parse(devices);
  }

  devices.push({
    id: device.id,
    hashId: _generateHash(device.id),
    name: device.name,
    serialNumber: "1234",
    firmwareVersion: "1.0.0",
  });
  localStorage.setItem(storageKey, JSON.stringify(devices));
};

const _checkIfDeviceIsOnLocalStorage = (device: any): boolean => {
  const storageKey = "readers";
  let devices: any = localStorage.getItem(storageKey);
  if (!devices) {
    return false;
  }

  devices = JSON.parse(devices);
  const deviceFound = devices.find((d: any) => d.id === device.id);
  if (deviceFound) {
    return true;
  }

  return false;
};

export const requestPushPermission = () => {
  if (!("Notification" in window)) {
    console.log("This browser does not support desktop notification");
  } else if (Notification.permission === "granted") {
    console.log("Notification permission granted");
    // Check whether notification permissions have already been granted;
    // if so, create a notification
    // const notification = new Notification("Hi there!");
    // notification.onclick = (event) => {
    //   console.log("Notification clicked: ", event);
    // }
  } else if (Notification.permission !== "denied") {
    // We need to ask the user for permission
    Notification.requestPermission().then((permission) => {
      // If the user accepts, let's create a notification
      if (permission === "granted") {
        console.log("Notification permission granted");
        // const notification = new window.Notification("Hi there!");
        // notification.onclick = (event) => {
        //   console.log("Notification clicked: ", event);
        // }
        return;
      }

      console.log("Notification permission DENIED");
    });
  }

  console.log("Notification.permission: ", Notification.permission);
}

export const sendMessageToDevice = async (command = "CMD08*", device: any): Promise<any> => {
  if (!device.bluetoothDevice) {
    console.log("Device not found");
    return false;
  }

  const write: any = await device.primaryService.getCharacteristic("0000abf1-0000-1000-8000-00805f9b34fb"); // escreve aqui
  const messageToDevice: any = new TextEncoder().encode(command);
  return await write.writeValue(messageToDevice);
};

const disconnectFromBluetoothDevice = (bluetoothDevice: any): boolean => {
  try {
    if (!bluetoothDevice) {
      return true;
    }

    // if (bluetoothDevice.gatt.connected) {
    //   bluetoothDevice.gatt.disconnect();
    //   console.clear();
    // }

    return true;
  } catch (error: any) {
    console.log("Error on desconnect device", error);
    return false;
  }
};

export const connectToBluetoothDevice = async (deviceName = "Metrix Reader") => {
  // const server = await device.gatt.connect();
  // device.addEventListener("gattserverdisconnected", onDisconnect);
  // return server;

  const options: any = {
    filters: [
      {
        namePrefix: deviceName,
        // namePrefix: reader.name,
        // namePrefix: device.name,
        // namePrefix: "Metrix Reader",
        acceptAllDevices: true,
      },
      {
        services: [
          "0000ABF0-0000-1000-8000-00805f9b34fb".toLowerCase(),
          "0000ABF1-0000-1000-8000-00805f9b34fb".toLowerCase(),
          "0000ABF2-0000-1000-8000-00805f9b34fb".toLowerCase(),
          "0000ABF3-0000-1000-8000-00805f9b34fb".toLowerCase(),
          "0000ABF4-0000-1000-8000-00805f9b34fb".toLowerCase(),
          "0000ABF7-0000-1000-8000-00805f9b34fb".toLowerCase(),
          "0000ABF8-0000-1000-8000-00805f9b34fb".toLowerCase(),
          "00000000-0000-0000-0000-00000000abf5".toLowerCase(),
          "00000000-0000-0000-0000-00000000abf6".toLowerCase(),
        ],
      },
    ],
  };

  const response: any = {
    isConnected: false,
    error: null,
    bluetoothDevice: null,
    bluetoothDeviceDetails: {
      id: null,
      name: null,
    },
    bluetoothServer: null,
    primaryService: null,
    characteristics: [],
    // onDisconnect: null,
  };

  try {
    const _window: any = window.navigator;
    const bluetoothDevice: any = await _window.bluetooth.requestDevice(options);

    if (!bluetoothDevice) {
      console.log("Device not found");
      response.error = "Device not found";
      return response;
    }

    console.log("DEVICE", bluetoothDevice);

    // setIsConnected(true);
    // setBluetoothDevice(device);
    response.isConnected = true;
    response.bluetoothDevice = bluetoothDevice;
    response.bluetoothDeviceDetails.id = bluetoothDevice.id;
    response.bluetoothDeviceDetails.name = bluetoothDevice.name;

    if (!_checkIfDeviceIsOnLocalStorage(bluetoothDevice)) {
      _saveDeviceToLocalStorage(bluetoothDevice);
    }

    const bluetoothServer: any = await bluetoothDevice.gatt.connect();
    // console.log("bluetoothServer", bluetoothServer);
    response.bluetoothServer = bluetoothServer;


    const primaryServices: any = await bluetoothServer.getPrimaryServices();
    if (!primaryServices) {
      console.log("primaryServices not found");
      return;
    }

    const primaryService: any = primaryServices[0];

    // setPrimaryService(primaryService);

    const service: any = await bluetoothServer.getPrimaryService(primaryService.uuid);
    if (!service) {
      console.log("Whoops. Failed to access to Bluetooth. Try again.");
    }

    response.primaryService = primaryService;

    const chars: any = await primaryService.getCharacteristics();
    if (!chars) {
      console.log("chars not found");
      return;
    }

    response.characteristics = chars;

    chars.forEach((char: any) => {
      if (char.properties.notify || char.properties.indicate) {
        char.startNotifications();
        char.oncharacteristicvaluechanged = (event: any) => {
          console.group("oncharacteristicvaluechanged: ", char.uuid);
          console.log("Value changed: ", event.target.value);
          const value = event.target.value;
          const decoder = new TextDecoder("utf-8");
          const decodedValue = decoder.decode(value);
          console.log(`Received: ${decodedValue}`);
          console.groupEnd();
        };
      }

    });

    bluetoothServer.ongattserverdisconnnected = disconnectFromBluetoothDevice(bluetoothDevice);

    return response;
  } catch (error: any) {
    console.log("Error connecting device" ,error);
    // setError("Error: " + error.message);
  }
}

export const isMobile = (): boolean => {

  /**
   * This function is commented to test the app on Android devices
   */
  return false;
  const _window: any = window;

  _window.mobileAndTabletCheck = function() {
    let check = false;
    (function(a){
      // eslint-disable-next-line
      if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0,4))) check = true;
    })(navigator.userAgent||navigator.vendor||_window.opera);
    return check;
  };

  return _window.mobileAndTabletCheck();
};